import React from "reactn";
import { StepIndicator } from "../../../components/UI";
import Setup from "./Setup";
import AdditionalDetails from "./AdditionalDetails";
import GetPaid from "./GetPaid";
import Customization from "./Customization";
// import Email from "./EmailConnect";
import StepBar from "../../../components/UI/StepBar";
import Validators from "../../../validators";
import Axios from "axios";
import {
  formatOrganizationAddress,
  geocodeOrganizationAddress,
  hasCompleteOrganizationAddress,
  hasValidOrganizationCoordinates
} from "../../../lib/organizationAddress";

class OrganizationalProfile extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      step: 0,
      profile_completion_validation: null,
      timezone: this.global.organizationInfo.timezone,
      geocodingAddress: false
    };
    this.titles = [
      "Organization Profile",
      "Additional Details",
      "Get Paid! Link account",
      // "Connect your Email",
      "Customization"
    ];
    this.validate = [
      () =>
        Validators.Partners.Profile.ValidateOrganization(
          this.global.organizationInfo
        ),
      () =>
        Validators.Partners.Profile.ValidateAddDetails(
          this.global.organizationInfo
        ),
      () =>
        Validators.Partners.Profile.ValidateLikedBankAccount(
          this.global.organizationInfo
        ),
      () =>
        Validators.Partners.Profile.ValidateOrgCustomization(
          this.global.organizationInfo
        )
    ];
    this.steps = [
      { name: "Organization Profile", validateFn: this.validate[0] },
      { name: "Additional Details", validateFn: this.validate[1] },
      { name: "Get Paid! Link account", validateFn: this.validate[2] },
      // { name: "Connect your Email", validateFn: _ => true },
      { name: "Customization", validateFn: this.validate[3] } //this.validate[3]
    ];
    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Organization Profile", to: "/profile" }
      ]
    });
  }

  async componentDidMount() {
    if (!this.global.organizationInfo) {
      this.dispatch.profile_reset();
      return;
    }
  
    const params = this.props.location.query;
  
    // return from Stripe onboarding (or refresh)
    if (params && (params.onboarding || params.refresh)) {
      try {
        const res = await Axios.get(
          `${process.env.REACT_APP_API}/partners/organization_profile/preview`
        );
        if (res?.data?.success) {
          const payload = res.data.data;
          const profile = payload?.data || payload;
  
          if (profile) {
            this.setGlobal({
              organizationInfo: {
                ...this.global.organizationInfo,
                ...profile
              }
            });
            // Move to "Get Paid! Link account"
            this.setState({ step: 2 });
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        // remove query params
        this.props.history.replace(this.props.location.pathname);
      }
      return;
    }
  
  }

  geocodeAddressIfNeeded = async () => {
    const organizationInfo = this.global.organizationInfo;

    if (
      hasValidOrganizationCoordinates(organizationInfo) ||
      !hasCompleteOrganizationAddress(organizationInfo)
    ) {
      return;
    }

    this.setState({ geocodingAddress: true });

    const addressBeingGeocoded = formatOrganizationAddress(organizationInfo);
    const maps = window.google && window.google.maps;
    let coordinates = null;
    try {
      if (maps && typeof maps.Geocoder === "function") {
        coordinates = await geocodeOrganizationAddress(
          organizationInfo,
          new maps.Geocoder()
        );
      }
    } catch (error) {
      coordinates = null;
    }

    // Ignore a response for stale text if the user edited the form while the
    // geocoder was working.
    if (
      formatOrganizationAddress(this.global.organizationInfo) !==
      addressBeingGeocoded
    ) {
      this.setState({ geocodingAddress: false });
      return;
    }

    await this.setGlobal({
      organizationInfo: {
        ...this.global.organizationInfo,
        ...(coordinates || { main_lat: null, main_long: null })
      }
    });
    this.setState({
      geocodingAddress: false
    });
  };

  saveProfile = async e => {
    const { step } = this.state;
    const action = e.currentTarget.name;

    if (step === 0) {
      await this.geocodeAddressIfNeeded();
    }

    this.setGlobal({
      organizationInfo: {
        ...this.global.organizationInfo,
        profile_completion_validation: this.state.profile_completion_validation,
        timezone: this.state.timezone
      }
    });

    switch (action) {
      case "next":
        this.setState({ step: step + 1 });
        await this.dispatch.saveOrganizationalProfile();
        break;
      case "back":
        this.setState({ step: step - 1 });
        await this.dispatch.saveOrganizationalProfile();
        break;
      case "save":
        await this.dispatch.saveOrganizationalProfile();
        break;
      default:
        return;
    }
  };

  changePage = async page => {
    if (this.state.step === 0) {
      await this.geocodeAddressIfNeeded();
    }
    await this.dispatch.saveOrganizationalProfile();

    this.setState({ step: page });
  };

  getPage = () => {
    if (this.global.organizationInfo) {
      switch (this.state.step) {
        case 0:
          return <Setup />;
        case 1:
          return <AdditionalDetails />;
        case 2:
          return <GetPaid />;
        // case 3:
        //   return <Email />;
        case 3:
          return (
            <Customization
              timezone={this.state.timezone}
              updateTimeZoneFn={tzName => {
                this.setState({ timezone: tzName });
              }}
            />
          );
        default:
          return <Setup />;
      }
    }
  };

  checkValid() {
    const { step } = this.state;
    return this.validate[step] && !this.validate[step]();
  }

  getCompletion() {
    let completed = 0;

    for (let v of this.validate) {
      completed += v();
    }
    this.setState({ profile_completion_validation: completed });

    return (completed / this.validate.length) * 100;
  }

  render() {
    return (
      <div className="container-fluid">
        {/* Commented out to make space for Top Bar */}
        {/* <div className="cont">
          <h1 className="events-title-header">Organization Profile</h1>
        </div> */}
        <StepBar
          {...{
            steps: this.steps,
            changeFn: this.changePage,
            current: this.state.step
          }}
        />
        <StepIndicator value={this.getCompletion()} />
        {this.getPage()}
        <div className="cont mb-5">
          <div className="buttons w-100">
            <button
              onClick={this.saveProfile}
              disabled={
                this.state.step === 0 || this.state.geocodingAddress
              }
              name="back"
              className="nextbtn"
            >
              BACK
            </button>
            <button
              onClick={this.saveProfile}
              disabled={this.state.geocodingAddress}
              name="save"
              className="savebtn"
            >
              SAVE
            </button>
            <button
              onClick={this.saveProfile}
              disabled={
                this.state.step === this.titles.length - 1 ||
                this.checkValid() ||
                this.state.geocodingAddress
              }
              name="next"
              className="nextbtn"
            >
              NEXT
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default OrganizationalProfile;
